import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ChangePasswordTypes,
  ForgotPasswordTypes,
  LoginPayload,
  VerifyResetCodeTypes,
} from '@redux/auth/types';
import { AUTH_TOKEN } from 'constants/keyNames';
import {
  changePasswordApi,
  forgotPasswordUserApi,
  getCurrentUserApi,
  loginApi,
  verifyResetCodeApi,
} from 'api/auth';
import { apiWrapper } from '@redux/crudCreator/reduxUtils';
import { GetAllPayloadType } from '@redux/crudCreator/types';

export const logout = createAsyncThunk(
  'auth/logout',
  async (payload, thunkAPI) => {
    try {
      localStorage.removeItem(AUTH_TOKEN);
      return {};
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const login = createAsyncThunk(
  'auth/login',
  async (payload: LoginPayload, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
        },
        loginApi,
        payload,
      );
      if (response.accessToken) {
        localStorage.setItem(AUTH_TOKEN, response.accessToken);
        return response;
      }
      return thunkAPI.rejectWithValue(response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getCurrentUser = createAsyncThunk(
  'auth/getCurrentUser',
  async (payload: GetAllPayloadType, thunkAPI) => {
    try {
      const response = await apiWrapper({}, getCurrentUserApi);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const forgotPasswordUser = createAsyncThunk(
  'auth/forgotPasswordUser',
  async (payload: ForgotPasswordTypes, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
        },
        forgotPasswordUserApi,
        payload,
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const verifyResetCode = createAsyncThunk(
  'auth/verifyResetCode',
  async (payload: VerifyResetCodeTypes, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
        },
        verifyResetCodeApi,
        payload,
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const changePassword = createAsyncThunk(
  'auth/changePassword',
  async (payload: ChangePasswordTypes, thunkAPI) => {
    try {
      const response = await apiWrapper(
        {
          isShowSuccessNoti: false,
        },
        changePasswordApi,
        payload,
      );
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);
